import TechnicalRepresentativeScreen from './TechnicalRepresentativeScreen.js';

export default TechnicalRepresentativeScreen;
